import { createAction, handleActions } from 'redux-actions';
import update from 'immutability-helper';

import {
  modifyProjectTask,
  setProjectOrderLink,
} from '../features/projects/ducks';

import { getTimeInfo as getTimeInfoAPI } from '~services/api.helpers';

/**
 * ACTIONS
 */
export const completeOrder = createAction('COMPLETE_ORDER');
export const initializeForm = createAction('INITIALIZE_FORM');
export const setForm = createAction('SET_FORM');
export const setMessages = createAction('SET_MESSAGES');
export const setHelperData = createAction('SET_HELPER_DATA');
export const updateHelperData = createAction('UPDATE_HELPER_DATA');
export const setNewOrderData = createAction('SET_NEW_ORDER_DATA');
export const clearNewOrderData = createAction('CLEAR_NEW_ORDER_DATA');
export const setOrderId = createAction('SET_ORDER_ID');
export const newOrder = createAction('NEW_ORDER');
export const setTimeInfo = createAction('SET_TIMEINFO');
export const clearTimeInfo = createAction('CLEAR_TIMEINFO');
export const setExcludeFields = createAction('SET_EXCLUDE_FIELDS');

/**
 * REDUCERS
 */
const initialState = {
  done: false,
  form: { fields: [] },
  successMessage: '',
  errorMessage: '',
  helperData: {},
  newOrderData: '',
  orderId: '',
  timeInfo: {},
  exclude: [],
  initData: {},
};

export default handleActions(
  {
    INITIALIZE_FORM: () => initialState,
    COMPLETE_ORDER: (state, action) =>
      update(state, {
        done: { $set: true },
        lastCompletedTask: { $set: action.payload },
      }),
    SET_FORM: (state, action) =>
      update(state, {
        form: { $set: action.payload },
      }),
    SET_MESSAGES: (state, action) =>
      update(state, {
        successMessage: { $set: action.payload.success },
        errorMessage: { $set: action.payload.error },
      }),
    SET_HELPER_DATA: (state, action) =>
      update(state, {
        helperData: { $set: action.payload },
      }),
    UPDATE_HELPER_DATA: (state, { payload: { key, value } }) =>
      update(state, {
        helperData: {
          [key]: { $set: value },
        },
      }),
    SET_NEW_ORDER_DATA: (state, action) =>
      update(state, {
        newOrderData: { $set: action.payload },
      }),
    CLEAR_NEW_ORDER_DATA: state =>
      update(state, {
        newOrderData: { $set: '' },
      }),
    SET_ORDER_ID: (state, action) =>
      update(state, {
        orderId: { $set: action.payload },
      }),
    NEW_ORDER: state =>
      update(state, {
        done: { $set: false },
      }),
    SET_TIMEINFO: (state, action) =>
      update(state, {
        timeInfo: { $set: action.payload },
      }),
    CLEAR_TIMEINFO: state =>
      update(state, {
        timeInfo: { $set: {} },
      }),
    SET_EXCLUDE_FIELDS: (state, action) =>
      update(state, {
        exclude: { $set: action.payload },
      }),
    SET_INIT_DATA: (state, action) =>
      update(state, {
        initData: { $set: action.payload },
      }),
  },
  initialState
);

/**
 * THUNKS
 */

export function fetchTimeInfo(data = {}, formId) {
  return async (dispatch, getState) => {
    try {
      const timeInfo = await getTimeInfoAPI(
        formId || getState().form.form.id,
        data
      );
      dispatch(setTimeInfo(timeInfo));
    } catch (e) {
      console.log(e);
    }
  };
}

export const handleRedirection = (order, navigate, formik) => {
  return async (dispatch, getState) => {
    const state = getState();
    // Handle miniproject stuff
    const { projectOrderLink } = state.projects;

    if (projectOrderLink) {
      const { projectId, taskId, formId } = projectOrderLink;

      // If there's a form mismatch, skip linking
      if (projectId && taskId && formId === order.formId) {
        await modifyProjectTask(projectId, taskId, {
          orderId: order.id,
          id: taskId,
        });
        navigate(`/projektit/${projectId}`);
      }
    } else if (formik) {
      navigate('/valmis');
    }

    // Clean up
    if (projectOrderLink) dispatch(setProjectOrderLink(null));
  };
};
